const fileBase64 = {
    base64: '',
    title: ''
};

export default fileBase64;